<template>
    <div>
        <template class="table-head">
            <el-table :data="accessoryList" ref="dragTable">
                <el-table-column show-overflow-tooltip :prop="item.prop" :label="item.label"
                    v-for="(item, index) in accessoryItems" :key="index">
                </el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button @click="previewClick(scope.row)" type="text" size="small">预览</el-button>
                        <!-- 下载的时候需要 拼接这个ID 后端说 id =  attachmentId -->
                        <el-button @click="downloadClick(scope.row)" type="text" size="small">下载</el-button>
                        <el-button @click="cellClick(scope.row)" type="text"
                            :disabled="scope.row.substr1.indexOf('billAccount') !== -1 || scope.row.substr1.indexOf('account_yp') !== -1 ||
                            scope.row.substr1.indexOf('account_wd') !== -1 || annexesFlag"
                            size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-button type="text" @click="dialogVisible = true" :disabled="annexesFlag">+添加附件 </el-button>
        </template>
        <el-dialog title="上传附件" :visible.sync="dialogVisible" width="30%">
            <el-upload class="upload-demo" action multiple :limit="10" :on-remove="handleRemove" :before-upload="befUploadCheckFileSize"
                :http-request="submitUpload" :on-exceed="handleExceed" :file-list="fileList">
                <el-button size="mini" type="primary">+添加附件</el-button>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getSaveAnnexes, getDeleteAnnexes } from '../../../../api/settleDetails';
import { getControlParam, getTempDownUrlByPath } from '@/modules/transport/bms/api/common';
import { previewFile, checkExtensions, isImageFile, download } from '@/modules/transport/bms/utils/common.js';
export default {
    props: {
        accessoryList: {
            type: Array
        },
        accessoryItems: {
            type: Array
        },
        annexesFlag: {
            type: Boolean,
            default: true
        },
        businessId: {
            type: Number
        }
    },
    data() {
        return {
            dialogVisible: false,
            fileList: [],
            uploadDataArr: [],
            controlParamSize: 1024
        };
    },
    methods: {
        // 取消上传
        cancel() {
            this.dialogVisible = false;
            this.fileList = [];
            this.uploadDataArr = [];
        },
        // 确定上传
        submit() {
            this.saveAnnexes();
            this.dialogVisible = false;
            this.fileList = [];
            this.uploadDataArr = [];
        },
        // 下载
        downloadClick(row) {
            download(row.attachmentId, row.substr1);
        },
        // 预览
        previewClick(row) {
            getTempDownUrlByPath(row.attachmentId).then(res => {
                if (res.code === '0') {
                    const onlineViewType = ['doc', 'docx', 'xls', 'xlsx', 'xlsm', 'ppt', 'pptx'];
                    if (isImageFile(row.substr1) || checkExtensions(row.substr1, ['pdf'])) {
                        window.open(row.attachmentId);
                    } else if (checkExtensions(row.substr1, onlineViewType)) {
                        previewFile(res.data);
                    } else {
                        this.$message.warning('该格式文件只能通过下载查看！');
                    }
                }
            });
        },
        // 弹窗提示
        cellClick(row) {
            this.$confirm('此操作将删除该附件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteAnnexes(row.jobId);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 文件上传前校验
        befUploadCheckFileSize(file) {
            const isExceed = file.size / 1024 <= this.controlParamSize;
            if (!isExceed) {
                this.$message.warning('上传文件大小不能超过 ' + this.controlParamSize + 'KB');
                return false;
            }
        },
        // 删除单个附件
        handleRemove(file, fileList) {
            this.fileList = fileList;
            let temp = null;
            this.uploadDataArr.forEach((item, index) => {
                if (file.name === item.file.name) {
                    temp = index;
                }
            });
            this.uploadDataArr.splice(temp, 1);
        },
        submitUpload(uploadData) {
            if (uploadData) {
                this.uploadDataArr.push(uploadData);
            }
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        // 上传后端
        saveAnnexes() {
            const formData = new FormData();
            this.uploadDataArr.forEach((item, index) => {
                formData.append('files', item.file);
            });
            formData.append('businessId', this.businessId);
            formData.append('moduleCode', 'EfApApplyEditor');
            getSaveAnnexes(
                formData
            ).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('添加成功');
                    this.$emit('updateAnnexesList');
                }
            });
        },
        deleteAnnexes(id) {
            const formData = new FormData();
            formData.append('id', id);
            getDeleteAnnexes(formData).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('删除成功');
                    this.$emit('updateAnnexesList');
                }
            });
        },
        getControlParamSize() {
            // 获取系统控制参数
            const formData = new FormData();
            formData.append('controlParam', 'BMS_UPLOAD_FILE_SIZE_CONTROL');
            getControlParam(formData).then(res => {
                if (res && res.code === '0') {
                    this.controlParamSize = res.data.value;
                } else {
                    this.controlParamSize = 1024; // 默认1024KB
                }
            });
        }
    },
    mounted() {
        this.getControlParamSize();
    }
};
</script>

<style lang="less" scoped>

</style>
